import { Box, Tooltip } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import TimeAgo from 'timeago-react'
import CheckIcon from 'assets/icons/icon-check-primary.svg?react'
import BuilderHeaderChip from '../BuilderHeaderChip'
import { useCurrentCollaborativeMapInfo } from 'features/builder/hooks/collaboration'
import EllipsisWithTooltip from 'features/common/ui/utils/EllipsisWithTooltip'

export function CollaborationTitleChip() {
  const { map, userHasEditMapPermission, lockedByMe, locked, currentMapLockStatus } = useCurrentCollaborativeMapInfo()

  if (!map?.collaborative || !userHasEditMapPermission || !currentMapLockStatus || lockedByMe) {
    return null
  }

  const updatedAt = currentMapLockStatus?.unlockedAt || map?.updatedAt
  const email = currentMapLockStatus?.email || 'Other user'

  return (
    <Tooltip title={<TimeAgo opts={{ minInterval: 60 }} datetime={updatedAt || ''} />} placement="right">
      <Box style={{ overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: 'calc(100% - 1em)' }} pr={0.5}>
        <BuilderHeaderChip
          icon={!locked ? <CheckIcon /> : undefined}
          label={
            <EllipsisWithTooltip>
              <FormattedMessage
                id={locked ? 'builder.navBar.beingEditedBySomeone' : 'builder.navBar.someoneFinishedEditing'}
                values={{ user: email }}
              />
            </EllipsisWithTooltip>
          }
        />
      </Box>
    </Tooltip>
  )
}
